import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "tab"]

  connect() {
    this.currentPeriod = "full"
  }

  show(event) {
    const period = event.currentTarget.dataset.period
    if (period === this.currentPeriod) return
    this.currentPeriod = period

    this.tabTargets.forEach(t => {
      const active = t.dataset.period === period
      t.classList.toggle("bg-blue-600", active)
      t.classList.toggle("text-white", active)
      t.classList.toggle("bg-gray-200", !active)
      t.classList.toggle("dark:bg-gray-700", !active)
      t.classList.toggle("text-gray-700", !active)
      t.classList.toggle("dark:text-gray-300", !active)
    })

    this.panelTargets.forEach(p => {
      p.classList.toggle("hidden", p.dataset.period !== period)
    })
  }
}
